import React from "react";
import { useLocation } from "react-router-dom";
import { getHelpForPath } from "../common/helpContent";

export default function HelpPanel({ open, onClose }) {
  const location = useLocation();
  const content = getHelpForPath(location.pathname);

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed top-[73px] right-0 z-50 h-[calc(100vh-73px)] w-full max-w-sm bg-white shadow-lg border-l border-gray-200 flex flex-col transform transition-transform duration-200 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!open}
      >
        <div className="p-6 border-b border-gray-200 flex items-start justify-between">
          <div>
            <div className="text-xs font-medium uppercase tracking-wide text-rewardsco-600 mb-1">
              Page Help
            </div>
            <h2 className="text-lg font-medium text-gray-800">{content.title}</h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close help panel"
            className="ml-4 text-gray-400 hover:text-gray-600 focus-ring rounded"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-6">
          <p className="text-sm text-gray-700 leading-relaxed">{content.description}</p>

          {content.actions && content.actions.length > 0 && (
            <div>
              <h3 className="text-sm font-semibold text-gray-800 mb-2">On this page</h3>
              <ul className="space-y-2">
                {content.actions.map((action, index) => (
                  <li key={index} className="flex items-start text-sm text-gray-700">
                    <svg
                      className="w-4 h-4 mr-2 mt-0.5 text-rewardsco-500 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{action}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
